import { kbConfluenceContextResource } from '@atlassian/jira-router-resources-confluence-context/src/services/index.tsx';
import { getServicedeskPageContextResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';

export const getReportsWithKbResources = () => [
	...getServicedeskPageContextResources(),
	kbConfluenceContextResource,
];
